import { GalaxyApi, isHDCA } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
const DEFAULT_LIMIT = 50;
/**
 * Fetches the details of a collection.
 * @param params.id The ID of the collection (HDCA) to fetch.
 */
export async function fetchCollectionDetails(params) {
    const { data, error } = await GalaxyApi().GET("/api/dataset_collections/{id}", {
        params: { path: params },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
/**
 * Fetches the details of a collection.
 * @param params.id The ID of the collection (HDCA) to fetch.
 */
export async function fetchCollectionSummary(params) {
    const { data, error } = await GalaxyApi().GET("/api/dataset_collections/{id}", {
        params: {
            path: params,
            query: { view: "collection" },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function fetchCollectionElements(params) {
    const { data, error } = await GalaxyApi().GET("/api/dataset_collections/{hdca_id}/contents/{parent_id}", {
        params: {
            path: { hdca_id: params.hdcaId, parent_id: params.collectionId },
            query: { instance_type: "history", offset: params.offset, limit: params.limit },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function fetchElementsFromCollection(params) {
    const hdcaId = isHDCA(params.entry) ? params.entry.id : params.entry.hdca_id;
    const collectionId = isHDCA(params.entry) ? params.entry.collection_id : params.entry.id;
    return fetchCollectionElements({
        hdcaId: hdcaId,
        collectionId: collectionId,
        offset: params.offset ?? 0,
        limit: params.limit ?? DEFAULT_LIMIT,
    });
}
